module.exports = __webpack_public_path__ + "static/media/grubhub.c5bb250d.jpg";